import { render } from "./MsgLeftNav.vue?vue&type=template&id=6c9b99af&scoped=true"
import script from "./MsgLeftNav.vue?vue&type=script&lang=js"
export * from "./MsgLeftNav.vue?vue&type=script&lang=js"

import "./MsgLeftNav.vue?vue&type=style&index=0&id=6c9b99af&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9b99af"]])

export default __exports__